import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import logo from "../../assets/images/logo/bidbro-logo-text.png";
import logoLight from "../../assets/images/logo/bidbro-logo-text.png";
//import './Footer.css';

const popularLocations = [
  { city: "Virginia Beach", state: "va" },
  { city: "Raleigh", state: "nc" },
  { city: "Tampa", state: "fl" },
  { city: "Nashville", state: "tn" },
  { city: "Charlotte", state: "nc" },
  { city: "Austin", state: "tx" },
  { city: "Denver", state: "co" },
  { city: "Dallas", state: "tx" },
  { city: "Jacksonville", state: "fl" },
  { city: "Orlando", state: "fl" },
];

const Footer: React.FC = () => {
  return (
    <footer className="bg-dark-blue text-white py-5">
      <Container>
        <div className="d-flex flex-column align-items-center mb-5">
          <a href="/" className="mb-3">
            <img src={logo} alt="BidBro" className="footer-logo" />
          </a>
          <p
            className="text-center text-white-50 mx-auto"
            style={{ maxWidth: "500px" }}
          >
            BidBro - Construction Estimates Made Easy | Get Prices Up-Front from Licensed Pros
          </p>
        </div>
        <Row className="mb-5">
          <Col md="3">
            <h3 className="fw-bold fs-5 mb-3">About BidBro</h3>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a href="/#" className="text-light">
                  Home
                </a>
              </li>
              <li className="mb-2">
                <a href="/#how-it-works" className="text-light">
                  How It Works
                </a>
              </li>
              <li className="mb-2">
                <a href="/#services" className="text-light">
                  Services
                </a>
              </li>
              <li className="mb-2">
                <a href="/#resources" className="text-light">
                  Resources
                </a>
              </li>
              <li>
                <Link to="/releases" className="text-light">
                  Release Notes
                </Link>
              </li>
            </ul>
          </Col>
          <Col md="3">
            <h3 className="fw-bold fs-5 mb-3">Find Contractors</h3>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a href="/contractors" className="text-light">
                  Contractors
                </a>
              </li>
              <li className="mb-2">
                <a href="/contractors/categories" className="text-light">
                  Service Categories
                </a>
              </li>
              <li>
                <a href="/contractors/locations" className="text-light">
                  Service Locations
                </a>
              </li>
            </ul>
          </Col>
          <Col md="6">
            <h3 className="fw-bold fs-5 mb-3">Popular Locations</h3>
            <Row>
              {popularLocations.map((location, index) => (
                <Col md="6" key={index} className="mb-2">
                  <a
                    href={`/jobs/${location.state}/${location.city
                      .toLowerCase()
                      .replace(/ /g, "-")}`}
                    className="text-light"
                  >
                    <div className="d-flex align-items-center">
                      <MapPin className="me-2" size={16} />
                      <span>{location.city}</span>
                    </div>
                  </a>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>

        <div className="border-top border-white-20 pt-4 text-center">
          <p><Link to="/privacy-policy" style={{ marginLeft:'5px', fontWeight: 'bold', color: 'white' }}>
              BidBro Privacy Policy
            </Link> |

            <Link to="/terms-of-service" style={{ marginLeft:'5px', fontWeight: 'bold', color: 'white' }}>
              Terms Of Service
            </Link>
            </p>
          <p>&copy; 2025 BidBro. All rights reserved.</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;